// src/PushNotificationService.js
import { messaging } from "../config/firebaseConfig";
import { getToken } from "firebase/messaging";
import axios from "axios";
import { apiUrl, PORT } from "../environment";
import { toast } from "react-toastify";
import axiosClient from "../admin/services/axiosClient";
// Request permission for push notifications and get the token
export const requestPermissionAndGetToken = async () => {
  try {
    // Request notification permission from the user
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      // Get the FCM token
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_VAPIDKEY
      });

      if (currentToken) {
        // You can send the token to your server for storing it
        // await saveTokenToServer(currentToken);
      } else {
      }
    } else {
    }
  } catch (error) {
  }
};

// Function to send the token to your server (for storing in DB)
const saveTokenToServer = async (token) => {
  try {
    const response = await fetch("/api/save-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });

    if (response.ok) {
    } else {
    }
  } catch (error) {
  }
};


// Function to fetch notifications from the database
export const getNotificationApi = async (id) => {
  try {
    const response = await axiosClient.get(`/patient-service/notifications/${id}`);
    if (response.success) {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching notifications.");
  }
};

// Function to mark a notification as read


export const markNotificationAsReadApi = async (id, patientId) => {
  try {
    const response = await axiosClient.put(`/patient-service/mark-allnotification-asread/${id}?type=chat&patientId=${patientId}`);


    return response;

  } catch (err) {
    toast.error("An error occurred while marking the notification as read.");
  }
};


export const markSingleNotificationAsReadApi = async (id) => {
  try {
    const response = await axiosClient.put(`/patient-service/mark-notification-as-read/${id}`);


    return response;

  } catch (err) {
    console.error("Error marking notification as read:", err);
    toast.error("An error occurred while marking the notification as read.");
  }
};

// Function to fetch patient details by ID
export const getPatientDetailsById = async (id) => {
  try {
    const response = await axiosClient.get(`/patient-service/get-patient`, { params: { id } });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching patient details:", err);
    toast.error("An error occurred while fetching patient details.");
  }
};
